let angular = require('angular');
import './style.scss'
function leftPanelLink() {
    return {
        restrict: 'E',
        replace: true,
        transclude: {
            icon: '?panelIcon'
        },
        scope: {
            iconClass: '@',
            counter:'=?',
            text: '@',
            link: '@',
            onlyMobile: '=?',
            onlyFullSize: '=?',
            hiddenInShowMore: '=?'
        },
        template: require('./template.html')
        ,
        link: function ($scope, element, attrs, controller) {
            $scope.isCollapsed = true;
            $scope.link_href = $scope.link
        }
    };
}

angular.module('mmApp.shared.leftPanel.renderLeftPanel.leftPanelLink', [])
    .directive('leftPanelLink', leftPanelLink);

export default 'mmApp.shared.leftPanel.renderLeftPanel.leftPanelLink'